// Stripe presentment charge units, not ISO/payout exponents.
// Audited list preserved from the CRM MRR display (26 September 2026).
// Unknown currencies stay unavailable.
const ZERO_DECIMAL_CHARGE_CURRENCIES = new Set(
  "BIF CLP DJF GNF JPY KMF KRW MGA PYG RWF VND VUV XAF XOF XPF".split(" "),
);
const TWO_DECIMAL_CHARGE_CURRENCIES = new Set(
  (
    "AED AFN ALL AMD ANG AOA ARS AUD AWG AZN BAM BBD BDT BMD BND BOB " +
    "BRL BSD BWP BYN BZD CAD CDF CHF CNY COP CRC CVE CZK DKK DOP DZD " +
    "EGP ETB EUR FJD FKP GBP GEL GIP GMD GTQ GYD HKD HNL HTG HUF IDR " +
    "ILS INR ISK JMD KES KGS KHR KYD KZT LAK LBP LKR LRD LSL MAD MDL " +
    "MKD MMK MNT MOP MUR MVR MWK MXN MYR MZN NAD NGN NIO NOK NPR NZD " +
    "PAB PEN PGK PHP PKR PLN QAR RON RSD RUB SAR SBD SCR SEK SGD SHP " +
    "SLE SOS SRD STD SZL THB TJS TOP TRY TTD TWD TZS UAH UGX USD UYU " +
    "UZS WST XCD XCG YER ZAR ZMW"
  ).split(" "),
);

/** Scale of a stored Stripe charge-unit amount, or null when unverified. */
export const getCrmStripeChargeUnitScale = (currency: string): 0 | 2 | null => {
  const code = currency.toUpperCase();
  return ZERO_DECIMAL_CHARGE_CURRENCIES.has(code)
    ? 0
    : TWO_DECIMAL_CHARGE_CURRENCIES.has(code)
      ? 2
      : null;
};
